import { render, staticRenderFns } from "./ItemN.vue?vue&type=template&id=550857ac"
import script from "./ItemN.vue?vue&type=script&lang=js"
export * from "./ItemN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports